import React, { useState } from 'react';
import SimpleTable from 'components/common/SimpleTable';
import ButtonView from 'utils/buttons/ButtonView';
import ButtonEdit from 'utils/buttons/ButtonEdit';
// import PropTypes from 'prop-types';
import propsPDF from '../../../../assets/pdf/Manual-Alta-de-Propiedades.pdf';
import emprendimientosPDF from '../../../../assets/pdf/Manual-Alta-de-Emprendimientos.pdf';
import inmoUsuarioPDF from '../../../../assets/pdf/Manual-Datos-Inmobiliaria-y-Usuario.pdf';
import sistemaPDF from '../../../../assets/pdf/Manual-para-Ingreso-al-Sistema.pdf';
import rolesPDF from '../../../../assets/pdf/Manual-Usuarios-Adicionales-y-Roles.pdf';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import { useSelector } from 'react-redux';
import EditTutorialModal from './modals/EditTutorialModal';
import DeleteTutorialModal from './modals/DeleteTutorialModal';

const tutoriales = [
  {
    id: 1,
    name: 'Manual de Alta de Propiedades',
    date: '9/8/2023',
    pdf: propsPDF
  },
  {
    id: 2,
    name: 'Manual de Alta de Emprendimientos',
    date: '9/8/2023',
    pdf: emprendimientosPDF
  },
  {
    id: 3,
    name: 'Manual de Datos de la Inmobiliaria y del Usuario',
    date: '9/8/2023',
    pdf: inmoUsuarioPDF
  },
  {
    id: 4,
    name: 'Manual para el Ingreso al Sistema',
    date: '9/8/2023',
    pdf: sistemaPDF
  },
  {
    id: 5,
    name: 'Manual para Usuarios Adicionales y Roles',
    date: '9/8/2023',
    pdf: rolesPDF
  }
];

const ListaTutoriales = () => {
  const userLogged = useSelector(state => state.login.currentUser);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState({});

  const handleEditClick = tutorial => {
    setCurrentPDF(tutorial);
    setShowEditModal(true);
  };

  const handleEditClose = () => {
    setShowEditModal(false);
    setCurrentPDF({});
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setCurrentPDF({});
  };

  const handleDeleteClick = tutorial => {
    setCurrentPDF(tutorial);
    setShowDeleteModal(true);
  };

  const columns = [
    {
      accessor: 'name',
      Header: 'Nombre'
    },
    {
      accessor: 'date',
      Header: 'Fecha de publicación'
    },
    {
      accessor: 'id',
      Header: 'Acciones',
      disableSortBy: true,
      Cell: data => (
        <div className="d-flex justify-content-start gap-3">
          <ButtonView
            funcion={() => window.open(data.data[data.value - 1].pdf, '_blank')}
            iconEye
          />
          {userLogged && userLogged.typeOfUser === 'cucicba' && (
            <>
              <ButtonEdit
                funcion={() => handleEditClick(data.data[data.value - 1])}
              />
              <ButtonDelete
                funcion={() => handleDeleteClick(data.data[data.value - 1])}
              />
            </>
          )}
        </div>
      )
    }
  ];

  return (
    <>
      <SimpleTable
        columns={columns}
        data={tutoriales}
        emptyMessage={{ title: 'No hay tutoriales disponibles', message: ' ' }}
      />
      {showEditModal && (
        <EditTutorialModal
          show={showEditModal}
          handleClose={handleEditClose}
          currentPDF={currentPDF}
        />
      )}
      {showDeleteModal && (
        <DeleteTutorialModal
          show={showDeleteModal}
          handleClose={handleDeleteClose}
          currentPDF={currentPDF}
        />
      )}
    </>
  );
};

ListaTutoriales.propTypes = {};

export default ListaTutoriales;
